<template>
  <div>
    <v-list>

      <ListItem
        :title="book.editor"
        :subtitle="$t('fields.editor')"
      />

      <ListItem
        :title="book.subject"
        :subtitle="$t('fields.subject')"
      />

      <ListItem
        :title="book.isbn"
        :subtitle="$t('fields.isbn')"
      />
      <ListItem
        :title="book.title"
        :subtitle="$t('fields.title')"
      />
      <ListItem
        :title="book.internal_code"
        :subtitle="$t('fields.internal_code')"
      />
      <ListItem
        :title="book.author"
        :subtitle="$t('fields.author')"
      />
      <ListItem
        :title="book.volume"
        :subtitle="$t('fields.volume')"
      />
      <ListItem
        :title="book.price"
        :subtitle="$t('fields.price')"
      />
      <ListItem
        :title="book.pubblication_year"
        :subtitle="$t('fields.pubblication_year')"
      />

      <ListItem
        :title="this.getLabel(book.options.is_primary)"
        :subtitle="$t('fields.primary_school')"
      />

      <ListItem
        :title="this.getLabel(book.options.is_secondary)"
        :subtitle="$t('fields.secondary_school')"
      />

      <ListItem
        :title="this.getLabel(book.options.is_traceable)"
        :subtitle="$t('fields.traceable')"
      />
    </v-list>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import ListItem from '../../shared/Lists/ListItem';

  export default {
    name: 'EditorDetails',
    components: { ListItem },
    props: {
      book: {
        type: Object,
        default: () => {},
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      getLabel(status) {
        return status === 1 ? this.$t('fields.true') : this.$t('fields.false');
      },
    },
  };
</script>
